import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-second-chess-championship',
  templateUrl: './second-chess-championship.component.html',
  styleUrls: ['./second-chess-championship.component.scss']
})
export class SecondChessChampionshipComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
